import { Checkbox, DataSource, ExcludableTextbox, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPendingPayAdjustReport extends Layout {
    checkboxSubtotalByTractor: Checkbox;
    dateboxCutoffDate: Textbox;
    excludabletextboxGLAccounts: ExcludableTextbox;
    excludabletextboxPayAdjustCodes: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    panelReportType: Panel;
    sourcePendingPayAdjust: DataSource;
    switchReportType: Switch;
    textboxGroupBy: Textbox;
    textboxPayeeType: Textbox;
}
